/* URSA card hover (testing theme, 6 Oct 2026, premium motion pack idea 4).
   Product cards in grids slowly cross-fade to their second photo on hover (the theme's own version
   jumped instantly). Cards with one photo keep the theme's subtle zoom.
   Remove: delete the ursa-card-hover.js line in layout/theme.liquid. */
(function () {
  if (window.__ursaCardHover) return;
  window.__ursaCardHover = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  var css = '.ursa-ch{position:absolute;inset:0;z-index:2;pointer-events:none;overflow:hidden;opacity:0;transition:opacity .45s ease}' +
    '.ursa-ch img{display:block;width:100%;height:100%;object-fit:var(--ursa-ch-fit,cover);transform:scale(1.04);transition:transform 1.1s ' + EASE + '}' +
    '.ursa-ch.is-on{opacity:1;transition:opacity .6s ' + EASE + '}' +
    '.ursa-ch.is-on img{transform:none}' +
    (reduce ? '.ursa-ch,.ursa-ch img{transition:opacity .15s linear!important;transform:none!important}' : '');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* stop the theme's instant slide jump on hover; keep everything else it does */
  customElements.whenDefined('product-card').then(function () {
    var P = customElements.get('product-card').prototype;
    if (P.__ursaPatched) return;
    P.__ursaPatched = true;
    var prev = P.previewImage, reset = P.resetImage;
    P.previewImage = function (e) { if (e && e.pointerType === 'mouse') return; return prev && prev.apply(this, arguments); };
    P.resetImage = function (e) { if (e && e.pointerType === 'mouse') return; return reset && reset.apply(this, arguments); };
  });

  function second(gal) {
    var all = gal.querySelectorAll('slideshow-slide img, .product-media img');
    if (all.length < 2) return null;
    var im = all[1];
    var src = im.getAttribute('src') || '';
    if (!src) { var ss = im.getAttribute('srcset') || ''; src = ss.split(',').pop().trim().split(' ')[0]; }
    return src ? { src: src, srcset: im.getAttribute('srcset') || '', sizes: im.getAttribute('sizes') || '', fit: getComputedStyle(all[0]).objectFit } : null;
  }
  function ensure(gal) {
    if (gal.__ursaCh !== undefined) return gal.__ursaCh;
    var d = second(gal);
    if (!d) { gal.__ursaCh = null; return null; }
    if (getComputedStyle(gal).position === 'static') gal.style.position = 'relative';
    var o = document.createElement('div'); o.className = 'ursa-ch'; o.setAttribute('aria-hidden', 'true');
    var im = document.createElement('img'); im.alt = ''; im.decoding = 'async';
    if (d.srcset) { im.srcset = d.srcset; if (d.sizes) im.sizes = d.sizes; }
    im.src = d.src;
    o.style.setProperty('--ursa-ch-fit', d.fit || 'cover');
    o.appendChild(im); gal.appendChild(o);
    gal.__ursaCh = o;
    return o;
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var gal = e.target.closest && e.target.closest('product-card .card-gallery');
    if (!gal || gal.contains(e.relatedTarget)) return;
    var o = ensure(gal); if (!o) return;
    var im = o.firstChild;
    var go = function () { if (gal.matches(':hover')) o.classList.add('is-on'); };
    if (im.complete && im.naturalWidth) requestAnimationFrame(go); else im.onload = go;
  });
  document.addEventListener('pointerout', function (e) {
    var gal = e.target.closest && e.target.closest('product-card .card-gallery');
    if (!gal || gal.contains(e.relatedTarget)) return;
    if (gal.__ursaCh) gal.__ursaCh.classList.remove('is-on');
  });
  /* warm the second photos of cards near the screen so the fade never waits */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { ensure(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '200px' });
    var scan = function () { document.querySelectorAll('product-card .card-gallery').forEach(function (g) { if (!g.__ursaSeen) { g.__ursaSeen = 1; io.observe(g); } }); };
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
})();
